import { render, staticRenderFns } from "./DynamicSegments.vue?vue&type=template&id=4c9a7124&scoped=true"
import script from "./DynamicSegments.vue?vue&type=script&lang=js"
export * from "./DynamicSegments.vue?vue&type=script&lang=js"
import style0 from "./DynamicSegments.vue?vue&type=style&index=0&id=4c9a7124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9a7124",
  null
  
)

export default component.exports